import types from "../actionTypes";

export default (
  state = {
    maxSteps: 0,
    minSteps: 0,
    step: 1,
    isAdded: false,
    accomodationFormPdfLink: undefined,
    applicants: [],
    currentPage: 1,
    pageSize: 20,
    totalRows: 0,
    caseStatus: [],
    acmdEmployeeStatement: [],
    attachment: []
  },
  action
) => {
  switch (action.type) {
    case types.SET_ACMD_CASE_STATUS:
      return Object.assign({}, state, {
        caseStatus: action.caseStatus
      })
    case types.SET_ACCOMODATION_PAGE_NO:
      return Object.assign({}, state, {
        currentPage: action.currentPage
      })
    case types.SET_ACCOMODATION_PAGE_ROWS:
      return Object.assign({}, state, {
        totalRows: action.totalRows
      })
    case types.SET_ACCOMODATION_PAGE_SIZE:
      return Object.assign({}, state, {
        pageSize: action.pageSize
      })
    case types.SET_ACCOMODATION_APPLICANTS:
      return Object.assign({}, state, {
        applicants: action.applicant
      })
    case types.SET_ACCOMODATION_CURRENT_STEP:
      return Object.assign({}, state, { step: action.step });
    case types.SET_ACCOMODATION_MAX_STEPS:
      return Object.assign({}, state, { maxSteps: action.maxSteps });
    case types.SET_ACCOMODATION_MIN_STEPS:
      return Object.assign({}, state, { minSteps: action.minSteps });
    case types.SET_ACCOMODATION_IS_ADDED:
      return Object.assign({}, state, { isAdded: action.isAdded });
    case types.SET_ACCOMODATION_FORM_PDF:
      return Object.assign({}, state, { accomodationFormPdfLink: action.accomodationFormPdfLink });
    case types.SET_ACMD_STATEMENT:
      return Object.assign({}, state, { acmdEmployeeStatement: action.acmdEmployeeStatement });
    case types.SET_ATTACHMENT_ACMD:
      return Object.assign({}, state, {
        attachment: action.attachment,
      });
    default:
      return state;
  }
};
